import { get } from "lodash";
import { createSelector } from "reselect";
import { IPersonalSmartGoals } from "utils/interfaces/slp-form";
import { SlpFormState } from "./types";

const getPersonalAndSmartGoalsListBySlpId = (
  state: SlpFormState
): IPersonalSmartGoals[] | null =>
  get(state, "slpForm.personalAndSmartGoalsDataBySlpId", null);

export const getPersonalAndSmartGoalsListBySlpIdSelector = createSelector(
  getPersonalAndSmartGoalsListBySlpId,
  (list) => list
);
